import { useMemo, useState } from "react";
import ListaDesplegable from "../../ComponentesGlobales/ListaDesplegable";
import { filtrarOpcionesVentas } from "../../servicios/ventasReportesUtils";

const seleccionNumerica = (lista, valor) => lista.find((item) => Number(item.Id) === Number(valor)) || null;
const seleccionTexto = (lista, valor) => lista.find((item) => item.Id === valor || item.sDescripcion === valor) || null;

const FiltroDescripcion = ({ etiqueta, lista = [], seleccionado, onChange, disabled, cargando, placeholder }) => (
  <label>
    <span>{etiqueta}</span>
    <ListaDesplegable
      Lista={lista}
      Seleccionado={seleccionado}
      setValor={onChange}
      Buscando={cargando}
      Deshabilitado={disabled}
      ActualizarSoloAlSeleccionar
      Filtrar={filtrarOpcionesVentas}
      MostrarEstado={false}
      MensajeVacio="No hay coincidencias"
      Placeholder={placeholder}
      TituloNoSeleccionado={placeholder}
    />
  </label>
);

const VentasFiltros = ({ filtros, opciones, cargandoOpciones, onChange, onConsultar, onLimpiar, disabled }) => {
  const [mostrarMas, setMostrarMas] = useState(false);
  const filtrosAdicionales = useMemo(() => [
    filtros.ClienteId,
    filtros.MercaderiaId,
    filtros.OperadorId,
    filtros.Estado,
    filtros.FormaPago,
  ].filter(Boolean).length, [filtros]);

  return (
    <form className="ventas-filtros-panel" onSubmit={(e) => { e.preventDefault(); onConsultar(); }}>
      <div className="ventas-filtros-titulo">
        <div>
          <strong>Período</strong>
          <span>Elegí las fechas y, si hace falta, acotá la búsqueda.</span>
        </div>
        <button
          className="ventas-filtros-toggle ventas-boton-secundario"
          type="button"
          aria-expanded={mostrarMas}
          aria-controls="ventas-filtros-adicionales"
          onClick={() => setMostrarMas((actual) => !actual)}
        >
          <i className={`pi ${mostrarMas ? "pi-chevron-up" : "pi-sliders-h"}`} />
          Más filtros{filtrosAdicionales ? ` (${filtrosAdicionales})` : ""}
        </button>
      </div>

      <div className="ventas-filtros-principales">
        <div className="ventas-filtros-fechas">
          <label>Desde<input disabled={disabled} type="date" value={filtros.FechaDesde} onChange={(e) => onChange("FechaDesde", e.target.value)} /></label>
          <label>Hasta<input disabled={disabled} type="date" value={filtros.FechaHasta} onChange={(e) => onChange("FechaHasta", e.target.value)} /></label>
        </div>
        <div className="ventas-filtros-acciones">
          {(filtrosAdicionales > 0 || mostrarMas) && <button className="ventas-boton-secundario" type="button" disabled={disabled} onClick={onLimpiar}>Limpiar</button>}
          <button type="submit" disabled={disabled}><i className={`pi ${disabled ? "pi-spin pi-spinner" : "pi-search"}`} /> {disabled ? "Consultando..." : "Consultar"}</button>
        </div>
      </div>

      <div id="ventas-filtros-adicionales" className={`ventas-filtros-adicionales${mostrarMas ? " abierto" : ""}`} hidden={!mostrarMas}>
        <FiltroDescripcion etiqueta="Cliente" lista={opciones.clientes} seleccionado={seleccionNumerica(opciones.clientes, filtros.ClienteId)} onChange={(item) => onChange("ClienteId", item?.Id ?? "")} disabled={disabled} cargando={cargandoOpciones} placeholder="Todos los clientes" />
        <FiltroDescripcion etiqueta="Producto" lista={opciones.productos} seleccionado={seleccionNumerica(opciones.productos, filtros.MercaderiaId)} onChange={(item) => onChange("MercaderiaId", item?.Id ?? "")} disabled={disabled} cargando={cargandoOpciones} placeholder="Todos los productos" />
        <FiltroDescripcion etiqueta="Operador" lista={opciones.operadores} seleccionado={seleccionNumerica(opciones.operadores, filtros.OperadorId)} onChange={(item) => onChange("OperadorId", item?.Id ?? "")} disabled={disabled} cargando={cargandoOpciones} placeholder="Todos los operadores" />
        <FiltroDescripcion etiqueta="Estado" lista={opciones.estados} seleccionado={seleccionTexto(opciones.estados, filtros.Estado)} onChange={(item) => onChange("Estado", item?.Id ?? "")} disabled={disabled} placeholder="Todos los estados" />
        <FiltroDescripcion etiqueta="Forma de pago" lista={opciones.formasPago} seleccionado={seleccionTexto(opciones.formasPago, filtros.FormaPago)} onChange={(item) => onChange("FormaPago", item?.sDescripcion ?? "")} disabled={disabled} cargando={cargandoOpciones} placeholder="Todas las formas" />
      </div>
    </form>
  );
};

export default VentasFiltros;
